'use strict';

Object.defineProperty(exports, "__esModule", {
                            value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

require('angular-ui-bootstrap');

require('angular-ui-router');

require('angular-animate');

require('angular-moment');

require('angular-sanitize');

require('angular-i18n/angular-locale_es-es.js');

require('moment/locale/es.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'buscador.core.dependencies';

var ngModule = _angular2.default.module(MODULE_NAME, ['ui.bootstrap', 'ui.router', 'ngAnimate', 'angularMoment']);

exports.default = MODULE_NAME;


// WEBPACK FOOTER //
// ./src/busqueda/core/dependencies.js